import * as React from "react"
export const Svg_027 = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={59}
    height={59}
    fill="none"
  >
    <path
      fill="url(#a)"
      d="M29.5 49.256a3.896 3.896 0 1 0 0-7.791 3.896 3.896 0 0 0 0 7.79Z"
    />
    <path
      fill="url(#b)"
      d="M29.5 38.007c4.055 0 7.353 3.299 7.353 7.353a7.312 7.312 0 0 1-1.312 4.188h5.169l2.606-2.607V12.059L40.71 9.452H18.29l-2.606 2.607V46.94l2.606 2.607h5.169a7.312 7.312 0 0 1-1.312-4.188c0-4.054 3.298-7.353 7.353-7.353Zm-5.625-22.922h11.25v3.458h-11.25v-3.458ZM20.77 22h17.462v3.458H20.769v-3.457Zm0 6.916h17.462v3.458H20.769v-3.458Z"
    />
    <path
      fill="url(#c)"
      d="M52.538 0H6.462v59h17.02v-5.994h-6.624l-4.632-4.633V10.627l4.632-4.633h25.284l4.632 4.633v37.746l-4.632 4.633h-6.625V59h17.02V0Z"
    />
    <path
      fill="url(#d)"
      d="M29.5 52.714a7.32 7.32 0 0 1-2.56-.46V59h5.12v-6.746c-.798.297-1.66.46-2.56.46Z"
    />
    <defs>
      <linearGradient
        id="a"
        x1={27.406}
        x2={31.107}
        y1={42.633}
        y2={48.623}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="b"
        x1={22.074}
        x2={43.243}
        y1={15.466}
        y2={39.078}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="c"
        x1={17.117}
        x2={47.613}
        y1={8.85}
        y2={47.394}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
      <linearGradient
        id="d"
        x1={28.124}
        x2={31.633}
        y1={53.266}
        y2={57.575}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#004A80" />
        <stop offset={1} stopColor="#00C0F3" />
      </linearGradient>
    </defs>
  </svg>
)